module.exports = __webpack_public_path__ + "static/media/edit.bbeca2a1.png";